import * as React from 'react'
import { ToolState, FundTypes } from '../../models';
import Intro from './Intro';
import Funds from './Funds';
import Timeframe from './Timeframe';
import Choices from './Choices';

interface WalthroughProps extends ToolState {
  setWalkthroughComplete: () => object;
  setMonthlyContribution: (x: number) => object;
  setCapitalFund: (x: FundTypes) => object;
  setDigitalFund: (x: FundTypes) => object;
  setLumpSum: (x: number) => object;
  setDuration: (x: number) => object;
  setAllocation: (x: number) => object;
}

interface WalkthroughState {
  currentStep: number;
}

class Walkthrough extends React.Component<WalthroughProps, WalkthroughState> {
  constructor(props: WalthroughProps) {
    super(props);
    this.state = { currentStep: 1 }
  }

  public render() {
    return (
      <div>
        { this.state.currentStep === 1 &&
          <Intro next={this.next} skip={this.props.setWalkthroughComplete} />
        }

        { this.state.currentStep === 2 &&
          <Funds
            next={this.next}
            previous={this.previous}
            skip={this.props.setWalkthroughComplete}
            lumpSum={this.props.lumpSum}
            monthlyContribution={this.props.monthlyContribution}
            setMonthlyContribution={this.props.setMonthlyContribution}
            setLumpSum={this.props.setLumpSum}
          />
        }

        { this.state.currentStep === 3 &&
          <Timeframe
            next={this.next}
            previous={this.previous}
            skip={this.props.setWalkthroughComplete}
            duration={this.props.duration}
            setDuration={this.props.setDuration}
          />
        }

        { this.state.currentStep === 4 &&
          <Choices
            next={this.next}
            previous={this.previous}
            skip={this.props.setWalkthroughComplete}
            capitalFund={this.props.capitalFund}
            digitalFund={this.props.digitalFund}
            allocation={this.props.allocation}
            setAllocation={this.props.setAllocation}
            setCapitalFund={this.props.setCapitalFund}
            setDigitalFund={this.props.setDigitalFund}
          />
        }
      </div>
    );
  }

  private next = () => this.setState({ currentStep: this.state.currentStep + 1});
  private previous = () => this.setState({ currentStep: this.state.currentStep - 1});
}

export default Walkthrough;
